import React from 'react';
import { OFFER_ANCHOR } from '../../data/content';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  external?: boolean;
  size?: 'md' | 'lg';
  className?: string;
}
export function CtaButton({
  children,
  href = OFFER_ANCHOR,
  external = false,
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const sizes: Record<string, string> = {
    md: 'px-4 py-2.5 text-[0.78rem] sm:text-sm',
    lg: 'px-5 py-3 text-[0.85rem] sm:text-base'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`inline-flex w-full max-w-xl items-center justify-center rounded-lg border-b-4 border-gold bg-solar text-center font-sans font-black uppercase leading-tight tracking-wide text-coal shadow-[0_6px_18px_rgba(6,43,85,0.28)] transition-colors duration-150 ease-soft hover:bg-solar-dark ${sizes[size]} ${className}`} data-id="element-210" data-mp="1qvuqf6mio08j">
      {children}
    </a>;
}